// extracted by mini-css-extract-plugin
export default {"likeButton":"SS-z","unLikedButton":"TS-z","likedButton":"US-z"};